import axios from 'axios';
import { openModal } from '../../store/componentStores/GlobalModal/globalModal.actions';
import { MODAL_KEYS } from '../../utilities/constants';

axios.interceptors.response.use(undefined, async err => {
  if (err.response?.status === 401 || err.response?.data?.message === '401 Unauthorized') {
    localStorage.removeItem('user');
    openModal(
      {
        keyContentComponent: MODAL_KEYS.AUTH_MODAL,
        params: {
          shouldOpenCreateForm: false
        }
      },
      false,
      true
    );
  }
  return Promise.reject(err);
});
